
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import Rodolfo1 from '../../assets/landing/Rodolfo1.png'
import Rodolfo2 from '../../assets/landing/Rodolfo2.png'
import Rodolfo3 from '../../assets/landing/Rodolfo3.png'
import Bienvenida from '../Perfilamiento/Bienvenida';
import { ALGUIEN_MAS, BIENVENIDA, DATOS, EMBARAZO, INTER_CONTRATANE, PERSONA_MAYOR, SOLO_AM, SOLO_AM_AGREGAR, TIPO_FLUJO } from '../Utils/Constantes';
import Datos from '../Perfilamiento/Datos';
import Advertencias from '../Advertencias/Advertencias'
import { useNavigate } from 'react-router-dom';
import Inicio from '../AgregarMas/Inicio';
import SoloAM from '../SoloAlguienMas/SoloAM';

export default function Wrapper(props) {
  const navigate = useNavigate();
  const [datos, setDatos] = useState({});
  const [tipoFlujo, setTipoFlujo] = useState(0);
  const [isAdvertencia, setAdvertencia] = useState(false);
  const [isTitular, setTitular] = useState(false);
  const [tipoAdvertencia, setTipoAdvertencia] = useState(null);

  const handleContinuarBienvenida = (id) => {
    setDatos(JSON.parse(sessionStorage.getItem(INTER_CONTRATANE)));
    setTipoFlujo(id);
    sessionStorage.setItem(TIPO_FLUJO, id);
    if (id === 3) {
      //am
      navigate('/datos/solo-alguien-mas');
    } else {
      navigate('/datos-personales');
    }
  };

  const handleRegresarDeDatos = () => {
    //y debe borrar storage?
    setTipoFlujo(0);
    sessionStorage.setItem(TIPO_FLUJO, 0);
    navigate('/bienvenida');
  };

  const handleRegresarDeAlguienMas = () => {
    //y debe borrar storage?
    let tipoFlujo = JSON.parse(sessionStorage.getItem("tipoFlujo"));
    //setTipoFlujo(id);
    //sessionStorage.setItem(TIPO_FLUJO,id);
    if (tipoFlujo === 2) {
      navigate('/datos-personales');
    } else {
      navigate('/datos/solo-alguien-mas');
    }
  };

  const handleRegresarDeSoloAlguienMas = () => {
    //y debe borrar storage?
    setTipoFlujo(0);
    sessionStorage.setItem(TIPO_FLUJO, 0);
    navigate('/');
  };

  const handleAdvertencias = (tipo, titular) => {
    switch (tipo) {
      case 1:// H y M para mi persona mayor
        //setTipoFlujo(0);
        //sessionStorage.setItem(TIPO_FLUJO,0);
        setTitular(titular);
        setAdvertencia(true);
        setTipoAdvertencia(PERSONA_MAYOR);
        break;
      case 2:// M para mi embarazo
        //setTipoFlujo(0);
        //sessionStorage.setItem(TIPO_FLUJO,0);
        setTitular(titular);
        setAdvertencia(true);
        setTipoAdvertencia(EMBARAZO);
        break;

      default:
        break;
    }
  };

  const handleLimpiaAdvertencia = () => {
    setAdvertencia(false);
    setTipoAdvertencia(null);
  };

  const handleSalir = () => {
    sessionStorage.clear();
    navigate('/inicio');
  };

  useEffect(() => {
    if (window.sessionStorage.getItem(INTER_CONTRATANE)) {
      setDatos(JSON.parse(sessionStorage.getItem(INTER_CONTRATANE)));
    }
    /* Especifica cómo sanear este efecto:
    return function cleanup() {
    };*/
  }, []);

  return (
    <div className="container-wrapper">
      <Container maxWidth="lg">
        <Box className='mX-30'>
          <Grid container direction="row" justifyContent="center" alignItems="center"
            sx={{ maxHeight: '590px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
              <div className="imagen-flujo">
                {props.componente === BIENVENIDA &&
                  <img src={Rodolfo1} alt='' />
                }
                {(props.componente !== BIENVENIDA && !isAdvertencia) &&
                  <img src={Rodolfo2} alt='' />
                }
                {isAdvertencia &&
                  <img src={Rodolfo3} alt='' />
                }
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
              {(props.componente === BIENVENIDA && isAdvertencia === false) &&
                <Bienvenida datos={datos} handleContinuar={handleContinuarBienvenida} tipoFlujo={tipoFlujo} />
              }
              {(props.componente === DATOS && isAdvertencia === false) &&
                <Datos datos={datos} handleAdvertencias={handleAdvertencias} handleSalir={handleSalir}
                  tipoFlujo={tipoFlujo} handleRegresar={handleRegresarDeDatos} />
              }
              {(props.componente === ALGUIEN_MAS && isAdvertencia === false) &&
                <Inicio datos={datos} handleAdvertencias={handleAdvertencias} handleSalir={handleSalir}
                  tipoFlujo={tipoFlujo} handleRegresar={handleRegresarDeAlguienMas} />
              }
              {(props.componente === SOLO_AM && isAdvertencia === false) &&
                <SoloAM datos={datos} handleAdvertencias={handleAdvertencias} handleSalir={handleSalir}
                  tipoFlujo={tipoFlujo} handleRegresar={handleRegresarDeSoloAlguienMas} />
              }
              {(props.componente === SOLO_AM_AGREGAR && isAdvertencia === false) &&
                <Inicio datos={datos} handleAdvertencias={handleAdvertencias} handleSalir={handleSalir}
                  tipoFlujo={tipoFlujo} handleRegresar={handleRegresarDeAlguienMas} />
              }
              {isAdvertencia &&
                <Advertencias datos={datos} tipoAdvertencia={tipoAdvertencia} tipoFlujo={tipoFlujo}
                  isTitular={isTitular} handleLimpiaAdvertencia={handleLimpiaAdvertencia} handleSalir={handleSalir} />
              }
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}